"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'CardExpansion',
    props: {
        expansion: {
            type: String,
            required: true,
        },
        isCorporation: {
            type: Boolean,
            required: true,
        },
        isResourceCard: {
            type: Boolean,
            required: true,
        },
        compatibility: {
            type: Array,
            required: true,
        },
    },
    methods: {
        iconClass(module) {
            return module === 'base' ? '' : module + '-icon';
        },
    },
    computed: {
        modules() {
            return this.compatibility.filter((e) => e !== this.expansion);
        },
        templateClasses() {
            if (this.isCorporation) {
                return 'card-corporation-expansion';
            }
            else {
                if (this.isResourceCard) {
                    return 'resource-card-icon-expansion-container';
                }
                else {
                    return 'project-icon-expansion-container';
                }
            }
        },
    },
});
